<template>
    <div class="property-saved-searches-card-footer d-flex align-items-center justify-content-between">
        <b-form-checkbox
            :disabled="isLoading"
            name="checkbox-subscribe"
            v-model="currentSearchAlertSubscriber.enabled"
            @input="onCheckboxClicked"
            @click.native.stop
            inline
        >
            Notify me when new homes match my criteria
        </b-form-checkbox>

        <div
            v-if="users.length"
            class="d-flex align-items-center font-size-sm text-gray-800 cursor-pointer"
            @click.stop="displayShareModal"
        >
            Shared with
            <storage-avatar-nested
                class="ml-2"
                :users="users"
            />
        </div>

        <b-button
            v-else
            pill
            size="sm"
            :disabled="isLoading"
            @click.stop="displayShareModal"
        >
            <i class="fas fa-share font-size-sm" />
            Share
        </b-button>
    </div>
</template>

<script>
    import './PropertySavedSearchesCardFooter.scss';
    import PropertySearchFilterAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/PropertySearchFilterAppResource";
    import SearchAlertSubscriberAppResource, {
        NOTIFICATION_FREQUENCY,
        NOTIFICATION_TYPE
    } from "@milestoneslabs/milestones-core-js/src/AppResources/SearchAlertSubscriberAppResource";
    import SavedSearchAlertsMixin from "../../../../mixins/SavedSearchAlertsMixin";
    import {PROPERTY_SAVED_SEARCHES_SHARE_MODAL_DISPLAY}
        from "../../PropertySavedSearchesShareModal/PropertySavedSearchesShareModal";
    import {AppResourceCollection} from "@milestoneslabs/milestones-js-engine";

    import StorageAvatarNested from "../../../StorageImage/StorageAvatarNested";

    export default {
        name: "PropertySavedSearchesCardFooter",

        mixins: [
            SavedSearchAlertsMixin,
        ],

        components: {
            StorageAvatarNested,
        },

        props: {
            propertySearchFilterAppResource: {
                type: PropertySearchFilterAppResource,
                required: true,
            }
        },

        data() {
            return {
                currentSearchAlertSubscriber: null,
                event: Math.random().toString(36).substr(2, 9),
            };
        },

        computed: {
            searchAlertSubscribers() {
                if (
                    this.propertySearchFilterAppResource.searchAlertSubscribers &&
                    this.propertySearchFilterAppResource.searchAlertSubscribers.length
                ) {
                    return this.propertySearchFilterAppResource.searchAlertSubscribers.toArray();
                }
                return [];
            },

            users() {
                if (this.isLoading) {
                    return [];
                }
                const users = [];
                for (let subscriber of this.searchAlertSubscribers) {
                    if (subscriber.enabled && (subscriber.projectMemberUuid !== this.currentProjectMemberUuid)) {
                        users.push(subscriber.projectMember.user);
                    }
                }

                return users;
            },
        },

        beforeMount() {
            this.currentSearchAlertSubscriber = this.getCurrentSearchAlertSubscriber();
            this.$bus.$on(this.event, this.handleShareEvent);
        },

        beforeDestroy() {
            this.$bus.$off(this.event, this.handleShareEvent);
        },

        methods: {
            getCurrentSearchAlertSubscriber() {
                let existingSubscriber = this.searchAlertSubscribers.find(
                    sub => sub.projectMemberUuid === this.currentProjectMemberUuid
                );

                if (existingSubscriber) {
                    return existingSubscriber;
                }

                return new SearchAlertSubscriberAppResource({
                    attributes: {
                        propertySearchFilterUuid: this.propertySearchFilterAppResource.uuid,
                        projectMemberUuid: this.currentProjectMemberUuid,
                        inviterProjectMemberUuid: this.currentProjectMemberUuid,
                        notificationType: NOTIFICATION_TYPE.EMAIL,
                        notificationFrequencyInMins: NOTIFICATION_FREQUENCY.FOUR_HOURS,
                        enabled: false,
                    }
                });
            },

            async onCheckboxClicked(value) {
                await this.subscribeUsers(this.propertySearchFilterAppResource, [this.currentSearchAlertSubscriber]);
                this.getCurrentSearchAlertSubscriber();
            },

            displayShareModal() {
                let collection = new AppResourceCollection('workspace-organization-Member');
                this.propertySearchFilterAppResource.searchAlertSubscribers.forEach((sub) => {
                    if (sub.enabled && (sub.projectMember.uuid !== this.currentProjectMemberUuid)) {
                        collection.addResource(sub.projectMember);
                    }
                });
                this.$bus.$emit(
                    PROPERTY_SAVED_SEARCHES_SHARE_MODAL_DISPLAY,
                    {
                        entity: collection,
                        event: this.event,
                    }
                );
            },

            handleShareEvent(projectMembers) {
                if (!Array.isArray(projectMembers)) {
                    throw new Error('Invalid payload, projectMembers should be an array.');
                }
                this.updateSubscribers(this.propertySearchFilterAppResource, projectMembers);
            }
        },
    };
</script>
